import { Route, Switch } from 'react-router-dom-v5'
import { genPath } from '../../utils/genPath'
import { useContextCosign } from '../useContextCosign'
import { CosignAuthValidator } from './CosignAuthValidator'
import { CouponReferralBindLine } from './couponReferral/CouponReferralBindLine'
import { LoginPortal } from './login/LoginPortal'
import { BindEmailPortal } from './myAccount/BindEmailPortal'
import { BindPhonePortal } from './myAccount/BindPhonePortal'
import { EditAccount } from './myAccount/EditAccount'
import { PasswordChange } from './password/PasswordChange'
import { PasswordRegister } from './password/PasswordRegister'
import { PasswordReset } from './password/PasswordReset'
import { PasswordSuccess } from './password/PasswordSuccess'

export function CosignRoutes() {
  const { emailLogin, routeMap } = useContextCosign()
  return (
    <Switch>
      <Route path={routeMap?.login || genPath('/my-account')} exact>
        <LoginPortal />
      </Route>
      <Switch>
        <Route path={genPath('/password/register')}>
          <CosignAuthValidator />
          <PasswordRegister />
        </Route>
        <Route path={routeMap?.passwordChange || genPath('/password/change')}>
          <CosignAuthValidator />
          <PasswordChange />
        </Route>
        <Route path={routeMap?.passwordReset || genPath('/password/reset')}>
          <CosignAuthValidator />
          <PasswordReset />
        </Route>
        <Route path={routeMap?.passwordSuccess || genPath('/password/success')}>
          <CosignAuthValidator />
          <PasswordSuccess />
        </Route>
        <Route path={routeMap?.bindPhone || genPath('/bind-phone')}>
          <CosignAuthValidator />
          <BindPhonePortal />
        </Route>
        <Route path={genPath('/coupon-referral-line')}>
          <CosignAuthValidator />
          <CouponReferralBindLine />
        </Route>
        {emailLogin && (
          <Route path={genPath('/bind-email')}>
            <CosignAuthValidator />
            <BindEmailPortal />
          </Route>
        )}
        <Route path={routeMap?.editAccount || genPath('/my-account/edit-account')}>
          <CosignAuthValidator />
          <EditAccount />
        </Route>
      </Switch>
    </Switch>
  )
}
